import { render, staticRenderFns } from "./PlanBoard.vue?vue&type=template&id=1e5ac5af&scoped=true"
import script from "./PlanBoard.vue?vue&type=script&lang=js"
export * from "./PlanBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5ac5af",
  null
  
)

export default component.exports